import { useEffect } from 'react';
import includes from 'lodash/includes';
import castArray from 'lodash/castArray';
import isNode from '../utils/isNode';

export default (keys, eventHandler, dependencies = []) => (
  useEffect(() => {
    if (isNode()) {
      return null;
    }

    const keyArray = castArray(keys);

    const handleOnEscape = (e) => {
      if (includes(keyArray, e.key)) {
        eventHandler(e);
      }
    };

    document.addEventListener('keyup', handleOnEscape);

    return () => document.removeEventListener('keyup', handleOnEscape);
  }, dependencies)
);
